import NEW_BOOKING_STEPS from 'constants/newBookingSteps';

const COMMUNAL = Object.freeze({
    ownerPetDetails: NEW_BOOKING_STEPS.ownerPetDetails,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default COMMUNAL;
